import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.promise.finally.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { IntervalTimer } from '../../../base/common/async.js';
import { Disposable, dispose as _dispose, toDisposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { SimpleWorkerClient, logOnceWebWorkerWarning } from '../../../base/common/worker/simpleWorker.js';
import { DefaultWorkerFactory } from '../../../base/worker/defaultWorkerFactory.js';
import { Range } from '../core/range.js';
import * as modes from '../modes.js';
import { LanguageConfigurationRegistry } from '../modes/languageConfigurationRegistry.js';
import { EditorSimpleWorker } from './editorSimpleWorker.js';
import { IModelService } from './modelService.js';
import { ITextResourceConfigurationService } from './textResourceConfigurationService.js';
import { regExpFlags } from '../../../base/common/strings.js';
import { isNonEmptyArray } from '../../../base/common/arrays.js';
import { ILogService } from '../../../platform/log/common/log.js';
import { StopWatch } from '../../../base/common/stopwatch.js';
import { canceled } from '../../../base/common/errors.js';
/**
 * Stop syncing a model to the worker if it was not needed for 1 min.
 */

var STOP_SYNC_MODEL_DELTA_TIME_MS = 60 * 1000;
/**
 * Stop the worker if it was not needed for 5 min.
 */

var STOP_WORKER_DELTA_TIME_MS = 5 * 60 * 1000;

function canSyncModel(modelService, resource) {
  var model = modelService.getModel(resource);

  if (!model) {
    return false;
  }

  if (model.isTooLargeForSyncing()) {
    return false;
  }

  return true;
}

var EditorWorkerServiceImpl = /*#__PURE__*/function (_Disposable) {
  _inherits(EditorWorkerServiceImpl, _Disposable);

  var _super = _createSuper(EditorWorkerServiceImpl);

  function EditorWorkerServiceImpl(modelService, configurationService, logService) {
    var _this;

    _classCallCheck(this, EditorWorkerServiceImpl);

    _this = _super.call(this);
    _this._modelService = modelService;
    _this._workerManager = _this._register(new WorkerManager(_this._modelService));
    _this._logService = logService; // register default link-provider and default completions-provider

    _this._register(modes.LinkProviderRegistry.register('*', {
      provideLinks: function provideLinks(model, token) {
        if (!canSyncModel(_this._modelService, model.uri)) {
          return Promise.resolve({
            links: []
          }); // File too large
        }

        return _this._workerManager.withWorker().then(function (client) {
          return client.computeLinks(model.uri);
        }).then(function (links) {
          return links && {
            links: links
          };
        });
      }
    }));

    _this._register(modes.CompletionProviderRegistry.register('*', new WordBasedCompletionItemProvider(_this._workerManager, configurationService, _this._modelService)));

    return _this;
  }

  _createClass(EditorWorkerServiceImpl, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(EditorWorkerServiceImpl.prototype), "dispose", this).call(this);
    }
  }, {
    key: "canComputeDiff",
    value: function canComputeDiff(original, modified) {
      return canSyncModel(this._modelService, original) && canSyncModel(this._modelService, modified);
    }
  }, {
    key: "computeDiff",
    value: function computeDiff(original, modified, ignoreTrimWhitespace, maxComputationTime) {
      return this._workerManager.withWorker().then(function (client) {
        return client.computeDiff(original, modified, ignoreTrimWhitespace, maxComputationTime);
      });
    }
  }, {
    key: "computeMoreMinimalEdits",
    value: function computeMoreMinimalEdits(resource, edits) {
      var _this2 = this;

      if (isNonEmptyArray(edits)) {
        if (!canSyncModel(this._modelService, resource)) {
          return Promise.resolve(edits); // File too large
        }

        var sw = StopWatch.create(true);

        var result = this._workerManager.withWorker().then(function (client) {
          return client.computeMoreMinimalEdits(resource, edits);
        });

        result.finally(function () {
          return _this2._logService.trace('FORMAT#computeMoreMinimalEdits', resource.toString(true), sw.elapsed());
        });
        return result;
      } else {
        return Promise.resolve(undefined);
      }
    }
  }, {
    key: "canNavigateValueSet",
    value: function canNavigateValueSet(resource) {
      return canSyncModel(this._modelService, resource);
    }
  }, {
    key: "navigateValueSet",
    value: function navigateValueSet(resource, range, up) {
      return this._workerManager.withWorker().then(function (client) {
        return client.navigateValueSet(resource, range, up);
      });
    }
  }, {
    key: "canComputeWordRanges",
    value: function canComputeWordRanges(resource) {
      return canSyncModel(this._modelService, resource);
    }
  }, {
    key: "computeWordRanges",
    value: function computeWordRanges(resource, range) {
      return this._workerManager.withWorker().then(function (client) {
        return client.computeWordRanges(resource, range);
      });
    }
  }]);

  return EditorWorkerServiceImpl;
}(Disposable);

EditorWorkerServiceImpl = __decorate([__param(0, IModelService), __param(1, ITextResourceConfigurationService), __param(2, ILogService)], EditorWorkerServiceImpl);
export { EditorWorkerServiceImpl };

var WordBasedCompletionItemProvider = /*#__PURE__*/function () {
  function WordBasedCompletionItemProvider(workerManager, configurationService, modelService) {
    _classCallCheck(this, WordBasedCompletionItemProvider);

    this._debugDisplayName = 'wordbasedCompletions';
    this._workerManager = workerManager;
    this._configurationService = configurationService;
    this._modelService = modelService;
  }

  _createClass(WordBasedCompletionItemProvider, [{
    key: "provideCompletionItems",
    value: function provideCompletionItems(model, position) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$_configurationS, wordBasedSuggestions, word, replace, insert, client, words;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$_configurationS = this._configurationService.getValue(model.uri, position, 'editor'), wordBasedSuggestions = _this$_configurationS.wordBasedSuggestions;

                if (wordBasedSuggestions) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 3:
                if (canSyncModel(this._modelService, model.uri)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 5:
                word = model.getWordAtPosition(position);
                replace = !word ? Range.fromPositions(position) : new Range(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
                insert = replace.setEndPosition(position.lineNumber, position.column);
                _context.next = 10;
                return this._workerManager.withWorker();

              case 10:
                client = _context.sent;
                _context.next = 13;
                return client.textualSuggest(model.uri, position);

              case 13:
                words = _context.sent;

                if (words) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 16:
                return _context.abrupt("return", {
                  suggestions: words.map(function (word) {
                    return {
                      kind: 18
                      /* Text */
                      ,
                      label: word,
                      insertText: word,
                      range: {
                        insert: insert,
                        replace: replace
                      }
                    };
                  })
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return WordBasedCompletionItemProvider;
}();

var WorkerManager = /*#__PURE__*/function (_Disposable2) {
  _inherits(WorkerManager, _Disposable2);

  var _super2 = _createSuper(WorkerManager);

  function WorkerManager(modelService) {
    var _this3;

    _classCallCheck(this, WorkerManager);

    _this3 = _super2.call(this);
    _this3._modelService = modelService;
    _this3._editorWorkerClient = null;
    _this3._lastWorkerUsedTime = new Date().getTime();

    var stopWorkerInterval = _this3._register(new IntervalTimer());

    stopWorkerInterval.cancelAndSet(function () {
      return _this3._checkStopIdleWorker();
    }, Math.round(STOP_WORKER_DELTA_TIME_MS / 2));

    _this3._register(_this3._modelService.onModelRemoved(function (_) {
      return _this3._checkStopEmptyWorker();
    }));

    return _this3;
  }

  _createClass(WorkerManager, [{
    key: "dispose",
    value: function dispose() {
      if (this._editorWorkerClient) {
        this._editorWorkerClient.dispose();

        this._editorWorkerClient = null;
      }

      _get(_getPrototypeOf(WorkerManager.prototype), "dispose", this).call(this);
    }
    /**
     * Check if the model service has no more models and stop the worker if that is the case.
     */

  }, {
    key: "_checkStopEmptyWorker",
    value: function _checkStopEmptyWorker() {
      if (!this._editorWorkerClient) {
        return;
      }

      var models = this._modelService.getModels();

      if (models.length === 0) {
        // There are no more models => nothing possible for me to do
        this._editorWorkerClient.dispose();

        this._editorWorkerClient = null;
      }
    }
    /**
     * Check if the worker has been idle for a while and then stop it.
     */

  }, {
    key: "_checkStopIdleWorker",
    value: function _checkStopIdleWorker() {
      if (!this._editorWorkerClient) {
        return;
      }

      var timeSinceLastWorkerUsedTime = new Date().getTime() - this._lastWorkerUsedTime;

      if (timeSinceLastWorkerUsedTime > STOP_WORKER_DELTA_TIME_MS) {
        this._editorWorkerClient.dispose();

        this._editorWorkerClient = null;
      }
    }
  }, {
    key: "withWorker",
    value: function withWorker() {
      this._lastWorkerUsedTime = new Date().getTime();

      if (!this._editorWorkerClient) {
        this._editorWorkerClient = new EditorWorkerClient(this._modelService, false, 'editorWorkerService');
      }

      return Promise.resolve(this._editorWorkerClient);
    }
  }]);

  return WorkerManager;
}(Disposable);

var EditorModelManager = /*#__PURE__*/function (_Disposable3) {
  _inherits(EditorModelManager, _Disposable3);

  var _super3 = _createSuper(EditorModelManager);

  function EditorModelManager(proxy, modelService, keepIdleModels) {
    var _this4;

    _classCallCheck(this, EditorModelManager);

    _this4 = _super3.call(this);
    _this4._syncedModels = Object.create(null);
    _this4._syncedModelsLastUsedTime = Object.create(null);
    _this4._proxy = proxy;
    _this4._modelService = modelService;

    if (!keepIdleModels) {
      var timer = new IntervalTimer();
      timer.cancelAndSet(function () {
        return _this4._checkStopModelSync();
      }, Math.round(STOP_SYNC_MODEL_DELTA_TIME_MS / 2));

      _this4._register(timer);
    }

    return _this4;
  }

  _createClass(EditorModelManager, [{
    key: "dispose",
    value: function dispose() {
      for (var modelUrl in this._syncedModels) {
        _dispose(this._syncedModels[modelUrl]);
      }

      this._syncedModels = Object.create(null);
      this._syncedModelsLastUsedTime = Object.create(null);

      _get(_getPrototypeOf(EditorModelManager.prototype), "dispose", this).call(this);
    }
  }, {
    key: "ensureSyncedResources",
    value: function ensureSyncedResources(resources) {
      var _iterator = _createForOfIteratorHelper(resources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resource = _step.value;
          var resourceStr = resource.toString();

          if (!this._syncedModels[resourceStr]) {
            this._beginModelSync(resource);
          }

          if (this._syncedModels[resourceStr]) {
            this._syncedModelsLastUsedTime[resourceStr] = new Date().getTime();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_checkStopModelSync",
    value: function _checkStopModelSync() {
      var currentTime = new Date().getTime();
      var toRemove = [];

      for (var modelUrl in this._syncedModelsLastUsedTime) {
        var elapsedTime = currentTime - this._syncedModelsLastUsedTime[modelUrl];

        if (elapsedTime > STOP_SYNC_MODEL_DELTA_TIME_MS) {
          toRemove.push(modelUrl);
        }
      }

      for (var _i = 0, _toRemove = toRemove; _i < _toRemove.length; _i++) {
        var e = _toRemove[_i];

        this._stopModelSync(e);
      }
    }
  }, {
    key: "_beginModelSync",
    value: function _beginModelSync(resource) {
      var _this5 = this;

      var model = this._modelService.getModel(resource);

      if (!model) {
        return;
      }

      if (model.isTooLargeForSyncing()) {
        return;
      }

      var modelUrl = resource.toString();

      this._proxy.acceptNewModel({
        url: model.uri.toString(),
        lines: model.getLinesContent(),
        EOL: model.getEOL(),
        versionId: model.getVersionId()
      });

      var toDispose = new DisposableStore();
      toDispose.add(model.onDidChangeContent(function (e) {
        _this5._proxy.acceptModelChanged(modelUrl.toString(), e);
      }));
      toDispose.add(model.onWillDispose(function () {
        _this5._stopModelSync(modelUrl);
      }));
      toDispose.add(toDisposable(function () {
        _this5._proxy.acceptRemovedModel(modelUrl);
      }));
      this._syncedModels[modelUrl] = toDispose;
    }
  }, {
    key: "_stopModelSync",
    value: function _stopModelSync(modelUrl) {
      var toDispose = this._syncedModels[modelUrl];
      delete this._syncedModels[modelUrl];
      delete this._syncedModelsLastUsedTime[modelUrl];

      _dispose(toDispose);
    }
  }]);

  return EditorModelManager;
}(Disposable);

var SynchronousWorkerClient = /*#__PURE__*/function () {
  function SynchronousWorkerClient(instance) {
    _classCallCheck(this, SynchronousWorkerClient);

    this._instance = instance;
    this._proxyObj = Promise.resolve(this._instance);
  }

  _createClass(SynchronousWorkerClient, [{
    key: "dispose",
    value: function dispose() {
      this._instance.dispose();
    }
  }, {
    key: "getProxyObject",
    value: function getProxyObject() {
      return this._proxyObj;
    }
  }]);

  return SynchronousWorkerClient;
}();

export var EditorWorkerHost = /*#__PURE__*/function () {
  function EditorWorkerHost(workerClient) {
    _classCallCheck(this, EditorWorkerHost);

    this._workerClient = workerClient;
  } // foreign host request


  _createClass(EditorWorkerHost, [{
    key: "fhr",
    value: function fhr(method, args) {
      return this._workerClient.fhr(method, args);
    }
  }]);

  return EditorWorkerHost;
}();
export var EditorWorkerClient = /*#__PURE__*/function (_Disposable4) {
  _inherits(EditorWorkerClient, _Disposable4);

  var _super4 = _createSuper(EditorWorkerClient);

  function EditorWorkerClient(modelService, keepIdleModels, label) {
    var _this6;

    _classCallCheck(this, EditorWorkerClient);

    _this6 = _super4.call(this);
    _this6._disposed = false;
    _this6._modelService = modelService;
    _this6._keepIdleModels = keepIdleModels;
    _this6._workerFactory = new DefaultWorkerFactory(label);
    _this6._worker = null;
    _this6._modelManager = null;
    return _this6;
  } // foreign host request


  _createClass(EditorWorkerClient, [{
    key: "fhr",
    value: function fhr(method, args) {
      throw new Error("Not implemented!");
    }
  }, {
    key: "_getOrCreateWorker",
    value: function _getOrCreateWorker() {
      if (!this._worker) {
        try {
          this._worker = this._register(new SimpleWorkerClient(this._workerFactory, 'vs/editor/common/services/editorSimpleWorker', new EditorWorkerHost(this)));
        } catch (err) {
          logOnceWebWorkerWarning(err);
          this._worker = new SynchronousWorkerClient(new EditorSimpleWorker(new EditorWorkerHost(this), null));
        }
      }

      return this._worker;
    }
  }, {
    key: "_getProxy",
    value: function _getProxy() {
      var _this7 = this;

      return this._getOrCreateWorker().getProxyObject().then(undefined, function (err) {
        logOnceWebWorkerWarning(err);
        _this7._worker = new SynchronousWorkerClient(new EditorSimpleWorker(new EditorWorkerHost(_this7), null));
        return _this7._getOrCreateWorker().getProxyObject();
      });
    }
  }, {
    key: "_getOrCreateModelManager",
    value: function _getOrCreateModelManager(proxy) {
      if (!this._modelManager) {
        this._modelManager = this._register(new EditorModelManager(proxy, this._modelService, this._keepIdleModels));
      }

      return this._modelManager;
    }
  }, {
    key: "_withSyncedResources",
    value: function _withSyncedResources(resources) {
      var _this8 = this;

      if (this._disposed) {
        return Promise.reject(canceled());
      }

      return this._getProxy().then(function (proxy) {
        _this8._getOrCreateModelManager(proxy).ensureSyncedResources(resources);

        return proxy;
      });
    }
  }, {
    key: "computeDiff",
    value: function computeDiff(original, modified, ignoreTrimWhitespace, maxComputationTime) {
      return this._withSyncedResources([original, modified]).then(function (proxy) {
        return proxy.computeDiff(original.toString(), modified.toString(), ignoreTrimWhitespace, maxComputationTime);
      });
    }
  }, {
    key: "computeMoreMinimalEdits",
    value: function computeMoreMinimalEdits(resource, edits) {
      return this._withSyncedResources([resource]).then(function (proxy) {
        return proxy.computeMoreMinimalEdits(resource.toString(), edits);
      });
    }
  }, {
    key: "computeLinks",
    value: function computeLinks(resource) {
      return this._withSyncedResources([resource]).then(function (proxy) {
        return proxy.computeLinks(resource.toString());
      });
    }
  }, {
    key: "textualSuggest",
    value: function textualSuggest(resource, position) {
      var _this9 = this;

      return this._withSyncedResources([resource]).then(function (proxy) {
        var model = _this9._modelService.getModel(resource);

        if (!model) {
          return null;
        }

        var wordDefRegExp = LanguageConfigurationRegistry.getWordDefinition(model.getLanguageIdentifier().id);
        var wordDef = wordDefRegExp.source;
        var wordDefFlags = regExpFlags(wordDefRegExp);
        return proxy.textualSuggest(resource.toString(), position, wordDef, wordDefFlags);
      });
    }
  }, {
    key: "computeWordRanges",
    value: function computeWordRanges(resource, range) {
      var _this10 = this;

      return this._withSyncedResources([resource]).then(function (proxy) {
        var model = _this10._modelService.getModel(resource);

        if (!model) {
          return Promise.resolve(null);
        }

        var wordDefRegExp = LanguageConfigurationRegistry.getWordDefinition(model.getLanguageIdentifier().id);
        var wordDef = wordDefRegExp.source;
        var wordDefFlags = regExpFlags(wordDefRegExp);
        return proxy.computeWordRanges(resource.toString(), range, wordDef, wordDefFlags);
      });
    }
  }, {
    key: "navigateValueSet",
    value: function navigateValueSet(resource, range, up) {
      var _this11 = this;

      return this._withSyncedResources([resource]).then(function (proxy) {
        var model = _this11._modelService.getModel(resource);

        if (!model) {
          return null;
        }

        var wordDefRegExp = LanguageConfigurationRegistry.getWordDefinition(model.getLanguageIdentifier().id);
        var wordDef = wordDefRegExp.source;
        var wordDefFlags = regExpFlags(wordDefRegExp);
        return proxy.navigateValueSet(resource.toString(), range, up, wordDef, wordDefFlags);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(EditorWorkerClient.prototype), "dispose", this).call(this);

      this._disposed = true;
    }
  }]);

  return EditorWorkerClient;
}(Disposable);